module.exports = __webpack_public_path__ + "static/img/shiyi3.8cb28cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shiyi3.png
// module id = wF1Y
// module chunks = 0